import styled from "styled-components";

export const ContentWrapper_div = styled.div`
  text-align: center;
  margin: 0 auto;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 140px;
  padding-bottom: 100px;
  @media only screen and (max-width: 767.98px) {
    margin-top: 56px;
    padding-top: 50px;
    padding-bottom: 50px;
    height: 100vh;
    align-items: start;
  }
`;

export const bodyLogoBrand = styled.div`
  img {
    width: 184px;
    @media only screen and (max-width: 767.98px) {
      width: 149px;
    }
  }
`;

export const IdInput_Wrapper = styled.div`
  margin-top: 50px !important;
  width: 390px;
  margin: 0 auto;
  @media only screen and (max-width: 767.98px) {
    width: 100%;
    margin-top: 42px !important;
  }
`;

export const IdInput = styled.input`
  height: 50px;
  width: 100%;
  padding: 13px 20px;
  color: #b3b3b3;
  font-size: 13.999px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 2px solid #e1e1e1;
  border-radius: 5px;
  & + input {
    margin-top: 9px;
  }
  &:focus-visible {
    outline: none;
  }
  &::placeholder {
    color: #b3b3b3;
  }
  @media only screen and (max-width: 767.98px) {
    height: 40px;
    padding: 12px 16px;
    border-width: 1px;
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const FindId_SpanWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px !important;
  @media only screen and (max-width: 767.98px) {
    margin-top: 22px !important;
  }
`;
export const Login_SpanOne = styled.span`
  color: #656565;
  font-size: 14.998px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media only screen and (max-width: 767.98px) {
    font-size: 12px;
  }
`;
export const Login_SpanTwo = styled.span`
  color: #656565;
  font-size: 14.998px;
  font-style: normal;
  font-weight: 700;
  position: relative;
  line-height: normal;
  &::before {
    content: "";
    position: absolute;
    width: 2px;
    height: 13px;
    background-color: #e1e1e1;
    left: -1px;
    top: 5px;
    @media only screen and (max-width: 767.98px) {
      height: 10px;
    }
  }
`;
